export enum UnitStatus {
  OCCUPIED = 'Occupied',
  VACANT = 'Vacant',
  REPAIR = 'Under Repair',
  DELINQUENT = 'Delinquent'
}

export enum MaintenancePriority {
  CRITICAL = 'Critical',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low'
}

export interface CommunicationEntry {
  id: string;
  date: string;
  note: string;
}

export interface UnitDocument {
  id: string;
  name: string;
  type: string;
  data: string; // base64
}

export interface TaxPayment {
  amount: number;
  date: string;
}

export interface TaxYearRecord {
  payment1: TaxPayment;
  payment2: TaxPayment;
  comments: string;
}

export interface TaxInfo {
  records: Record<number, TaxYearRecord>;
  taxWebsite: string;
}

export interface EmploymentEntry {
  id: string;
  jobName: string;
  tenantName: string;
  startDate: string;
  monthlyIncome: number;
}

export interface Unit {
  id: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  status: UnitStatus;
  monthlyRent: number;
  lastInspectionDate: string;
  year: number;
  make: string;
  model: string;
  tenantName: string;
  tenantPhone: string;
  tenantEmail: string;
  spouseName: string;
  spousePhone: string;
  spouseEmail: string;
  childrenNames: string;
  leaseStart: string;
  leaseEnd: string; // Used as "Pay Off Date" in the UI
  moveInDate: string;
  salesAmount: number;
  driversLicense?: string; // base64
  employmentHistory: EmploymentEntry[];
  conditionNotes: string[];
  communicationLog: CommunicationEntry[];
  photos: string[];
  thumbnail?: string;
  documents: UnitDocument[];
  taxInfo?: TaxInfo;
}

export interface Transaction {
  id: string;
  unitId: string;
  amount: number;
  fee: number;
  date: string;
  category: 'Rent' | 'Utility' | 'Late Fee';
  notes?: string;
}

export interface AIEstimate {
  parts: number;
  labor: number;
  justification: string;
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  role: 'Owner' | 'Manager' | 'Admin';
  phone: string;
  joinedDate: string;
}

export interface RefurbProject {
  id: string;
  [key: string]: any;
}

export interface MaintenanceRequest {
  id: string;
  [key: string]: any;
}

export interface Announcement {
  id: string;
  [key: string]: any;
}

export interface Message {
  id: string;
  [key: string]: any;
}
